import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyInfo/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function saveDailyBuild (obj) {
  return axios({
    url: '/dailyInfo/saveDailyBuild',
    method: 'POST',
    data: obj
  })
}

export function saveDailyCuring (obj) {
  return axios({
    url: '/dailyInfo/saveDailyCuring',
    method: 'POST',
    data: obj
  })
}

export function modifyDailyBuild (obj) {
  return axios({
    url: '/dailyInfo/modifyDailyBuild',
    method: 'POST',
    data: obj
  })
}

export function modifyDailyCuring (obj) {
  return axios({
    url: '/dailyInfo/modifyDailyCuring',
    method: 'POST',
    data: obj
  })
}

export function dailyById (id) {
  return axios({
    url: '/dailyInfo/dailyById/' + id,
    method: 'Get'
  })
}

export function checkDailyInfo (id) {
  return axios({
    url: '/dailyInfo/checkDailyInfo/' + id,
    method: 'Get'
  })
}

export function agreeDailyInfo (id) {
  return axios({
    url: '/dailyInfo/agreeDailyInfo/' + id,
    method: 'Get'
  })
}

export function rejectDailyInfo (id) {
  return axios({
    url: '/dailyInfo/rejectDailyInfo/' + id,
    method: 'Get'
  })
}

export function delect (obj) {
  return axios({
    url: '/dailyInfo/delect',
    method: 'Post',
    data: obj
  })
}

export function exportExcel (params) {
  return axios({
    url: `/dailyInfo/dailyDownload`,
    responseType: 'blob',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 重置计算
export function resetSumByDaily (id) {
  return axios({
    url: '/dailyInfo/resetSumByDaily/' + id,
    method: 'Get'
  })
}
